import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiPaths } from '@env/paths';
import {
  AdminSeriesConfig,
  AdminSeriesRequest,
  AdminVehicleCodeRequest,
} from '@shared/models/filetype/AdminSeriesConfig';
import { AdminVp5VersionsConfig } from '@shared/models/filetype/AdminVp5VersionsConfig';
import { Observable } from 'rxjs';

import { EnvService } from './env.service';
import { FSFLogsResponse } from '@shared/models/FSFLogs';
import { AstaktSdpRequest, AstaktSdpResponse } from '@shared/models/Astaktinfo';

@Injectable({
  providedIn: 'root',
})
export class AstaktService {
    private dataManagerBaseUrl = '';
    constructor(private readonly httpClient: HttpClient, private readonly envService: EnvService) {
    this.dataManagerBaseUrl = `${envService.apiUrl}${apiPaths.fcscDatamanager}/api`;
  }

  getAstaktSDP(payload: AstaktSdpRequest): Observable<HttpResponse<AstaktSdpResponse>> {
    const url = `${this.dataManagerBaseUrl}/v1/astakt`;
    return this.httpClient.post(url, payload, {
      responseType: 'json',
      observe: 'response',
    });
  }
}